import React, { useEffect, useState } from "react";
import { paymentIntent } from "../../Store/api/student";
import { useDispatch } from "react-redux";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { Link } from "react-router-dom";
function Payment({ stripePromise, joinCode }) {
  const dispatch = useDispatch();
  const [clientSecret, setClientSecret] = useState("");
  const [err, setErr] = useState("");
  useEffect(() => {
    const url = new URL(window.location);
    const clientSecret = url.searchParams.get("payment_intent_client_secret");
    if (clientSecret) return;
    setErr("");
    dispatch(
      paymentIntent({
        body: { joinCode: joinCode },
        onSuccess: (res) => {
          setErr("");
          setClientSecret(res.data.data.clientSecret);
        },
        onError: (error) => {
          if (error.response) {
            if (error.response.data) {
              setErr(error.response.data.message);
            }
          } else {
            setErr("Something went wrong!");
          }
        },
      })
    );
  }, []);
  return (
    <div
      className="main_wrap_new "
      style={{ overflowY: "scroll", overflowX: "clip", height: "80vh" }}
    >
      <div
        className="links_wrap d-flex justify-content-between"
        style={{ margin: "45px  0px 16px 0px" }}
      >
        <span></span>
        <Link to={"/studentdashboard/overview"} className="icon_arrow">
          <span className="btn_pay_later  ml-auto pt-45 ">
            Pay later --{">"}
          </span>{" "}
        </Link>
      </div>
      <div className="main_content_inner">
        <h1 className="main_title  ">$25 a semester keeps access open</h1>
        <p className="f24">
          Select your payment type and checkout securely using Stripe.
        </p>
        {err && (
          <div
            style={{
              color: "red",
              fontSize: "18px",
              fontWeight: "bolder",
              marginBottom: "60px",
              marginTop: "32px",
              textAlign: "center",
            }}
          >
            {err}
          </div>
        )}
        {clientSecret && stripePromise && (
          <Elements stripe={stripePromise} options={{ clientSecret }}>
            <CheckoutForm />
          </Elements>
        )}
      </div>
    </div>
  );
}

export default Payment;
